import {
  HStack,
  Icon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import type {
  APIADPlatforms,
  APIListingPerformanceStat,
} from "models/types/api-listing";
import EmptyTable from "assets/icons/medium/empty-table.svg?react";
import { Empty } from "components/empty";
import { PerformanceAdCampaign } from "modules/vendor-portal/screens/performance/components/performance-ad-campaign";
import { ReachMarketingCta } from "modules/vendor-portal/screens/performance/components/reach-marketing-cta";
import { AD_PLATFORMS } from "modules/vendor-portal/screens/performance/utils/ad-platform-details";

type CampaignTabsProps = {
  adCampaigns?: APIListingPerformanceStat[];
  isLoading: boolean;
  allAdPlatformIds: APIADPlatforms[];
};
export function PerformanceTabs({
  allAdPlatformIds,
  adCampaigns,
  isLoading,
}: CampaignTabsProps) {
  const platforms = AD_PLATFORMS;
  return (
    <Tabs size={"md"} variant={"closedPanel"}>
      <TabList>
        {allAdPlatformIds.map((adPlatformId) =>
          platforms[adPlatformId] ? (
            <Tab key={adPlatformId}>
              <HStack>
                <Icon
                  as={platforms[adPlatformId].logo}
                  boxSize={"20px"}
                  color={"#FFFF"}
                />
                <Text>{platforms[adPlatformId].name}</Text>
              </HStack>
            </Tab>
          ) : null,
        )}
      </TabList>
      <TabPanels>
        {allAdPlatformIds?.map((adPlatformId) => {
          const campaign = adCampaigns?.find(
            (ad) => ad.format.id === adPlatformId,
          );

          if (!AD_PLATFORMS[adPlatformId]) {
            return null;
          }

          return (
            <TabPanel key={adPlatformId}>
              {!campaign && adPlatformId === "reach" ? (
                <ReachMarketingCta />
              ) : !campaign ? (
                <Empty
                  icon={<Icon as={EmptyTable} boxSize={"auto"} />}
                  emptyMessage={"Campaign data currently unavailable"}
                  emptyDesc={
                    "Performance details will appear here once data becomes available"
                  }
                />
              ) : (
                <PerformanceAdCampaign
                  adCampaign={campaign}
                  isLoading={isLoading}
                />
              )}
            </TabPanel>
          );
        })}
      </TabPanels>
    </Tabs>
  );
}
